/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const SettingsFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M5.33 4.54A10 10 0 0 1 8.88 2.5a4 4 0 0 0 6.24 0 10 10 0 0 1 3.55 2.04 4 4 0 0 0 3.12 5.41 10 10 0 0 1 0 4.1 4 4 0 0 0-3.12 5.4 10 10 0 0 1-3.55 2.05 4 4 0 0 0-6.24 0 10 10 0 0 1-3.55-2.05 4 4 0 0 0-3.12-5.4 10 10 0 0 1 0-4.1 4 4 0 0 0 3.12-5.4M13.5 14.6a3 3 0 1 0-3-5.2 3 3 0 0 0 3 5.2" />
  </Icon>
);
